import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatChipsModule } from '@angular/material/chips';
import { MatRadioModule } from '@angular/material/radio';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { CdkTableModule} from '@angular/cdk/table';
import { LayoutModule } from '@angular/cdk/layout';
import { MatBottomSheetModule} from '@angular/material/bottom-sheet';
import { MatSlideToggleModule} from '@angular/material/slide-toggle';
import { MatStepperModule} from '@angular/material/stepper';
import { MatTooltipModule} from '@angular/material/tooltip';
import { MatAutocompleteModule} from'@angular/material/autocomplete'
import { MatButtonToggleModule } from'@angular/material/button-toggle'
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  imports: [
    CommonModule,
    MatInputModule,
    MatButtonModule,
    LayoutModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatSnackBarModule,
    MatMenuModule,
    MatGridListModule,
    MatPaginatorModule,
    MatCheckboxModule,
    MatSelectModule,
    MatDialogModule,
    MatTabsModule,
    MatExpansionModule,
    MatProgressBarModule,
    MatTableModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatChipsModule,
    MatRadioModule,
    MatSidenavModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatRippleModule,
    CdkTableModule,
    MatBottomSheetModule,
    MatSlideToggleModule,
    MatStepperModule,
    MatTooltipModule,
    MatAutocompleteModule,
    MatButtonToggleModule,
  ],
  exports: [
    MatInputModule,
    MatButtonModule,
    LayoutModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatSnackBarModule,
    MatMenuModule,
    MatGridListModule,
    MatPaginatorModule,
    MatCheckboxModule,
    MatSelectModule,
    MatDialogModule,
    MatTabsModule,
    MatExpansionModule,
    MatProgressBarModule,
    MatTableModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatChipsModule,
    MatRadioModule,
    MatSidenavModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatRippleModule,
    CdkTableModule,
    MatBottomSheetModule,
    MatSlideToggleModule,
    MatStepperModule,
    MatTooltipModule,
    MatAutocompleteModule,
    MatButtonToggleModule,
  ]
})
export class AppMaterialModule { }